
import * as React from "react";
import {SettingsService} from "../../services/SettingsService";
import {getContainer} from "../../ioc/IOCSetup";
import {LoadingViewState, RouterView} from "../RouterView";
import {Form, FormListener} from "../form/Form";
import {RouteComponentProps, withRouter} from "react-router";
import {Fragment} from "react";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {Settings} from "../../http/protocol";
import { Validators } from "../form/Validators";
import { FormTextArea } from "../form/FormTextArea";

interface Props extends RouteComponentProps {

}

interface State extends LoadingViewState{
    settings?: Settings;
    validationMap? : any;

}

export class SettingsIntegrationsView extends RouterView<Props,State> implements FormListener<Settings>{

    settingsService: SettingsService;

    constructor(props:Props) {
        super(props);

        this.settingsService = getContainer().getSettingsService();

        this.state = {validationMap : {}, loading : true};
    }

    loadContent(): Promise<any> | undefined {
        return this.settingsService.getSettings().then((data) => {
            this.setState({settings:data});
        });
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        super.componentDidUpdate(prevProps, prevState);

    }
    formDidUpdate(formModel:Settings, validationMap : any) {
        this.setState({ settings : formModel, validationMap : validationMap});
    }

    onSubmit():Promise<any> {
        if(!this.state.settings) {
            return Promise.reject("Unable to save settings");
        }

        if(this.state.settings.freshChatConfiguration) {
            try {
                this.state.settings.freshChatConfiguration = JSON.stringify(JSON.parse(this.state.settings.freshChatConfiguration), null, 2);
                this.setState({settings : this.state.settings});
            } catch (error) {
                // Do nothing                
            }
        }
        
        return this.settingsService.saveSettings(this.state.settings)
            .catch(err=>{
                throw new Error("Unable to create/save settings");
            });
    }

    onSubmitError(){}

    getTitle() : string {
        return "Integration Settings";
    }

    renderContent() {
        if(!this.state.settings) {
            return <span></span>
        }
        let freshChatConfigurationExample = JSON.stringify({"content": { "headers" : {"chat": "Chat with our Team"} }});
        const {freshChatConfiguration} = this.state.settings;
        const configurationRows = freshChatConfiguration ? freshChatConfiguration.split('\n').length : 5;

        return(
            <Fragment>
                <Form className="form-horizontal" formListener={this} modelObject={this.state.settings} validationMap={this.state.validationMap}>
                    <div className={"card"}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Settings was updated successfully"/>
                                    <FormGroup className="form-group mb-3" model="facebookAppId">
                                        <label>Facebook App ID</label>
                                        <FormInput className="form-control" model="facebookAppId" type="text"/>
                                        <span className={"help-block"}>Leave empty to disable facebook login. You also need to configure Facebook App Secret in the Internal Settings</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="googleAnalyticsId">
                                        <label>Google Analytics Tracker</label>
                                        <FormInput className="form-control" model="googleAnalyticsId" type="text"/>
                                        <span className={"help-block"}>Google Analytics "TrackerId" goes here. Leave empty to disable google analytics.</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="googleCaptchaSiteKey">
                                        <label>Google Captcha Site Key</label>
                                        <FormInput className="form-control" model="googleCaptchaSiteKey" type="text"/>
                                        <span className={"help-block"}>Google Captcha "Site key" goes here. Leave empty to disable google captcha.</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="custom-control custom-checkbox" model="freshChatEnabled">
                                        <FormInput className="custom-control-input" model="freshChatEnabled" id={"freshChatEnabled"} type="checkbox"/>
                                        <label htmlFor={"freshChatEnabled"} className={"custom-control-label"}>Enable FreshChat</label><br/>
                                        <span className={"help-block"}>Enables Freshchat customer support (https://web.freshchat.com)</span>
                                    </FormGroup>
                                    <FormGroup className="form-group mb-3" model="freshChatWidgetToken">
                                        <label>FreshChat Widget Token</label>
                                        <FormInput className="form-control" model="freshChatWidgetToken" type="text"/>
                                        <span className={"help-block"}>Needed for Freshchat  integration</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="freshChatHost">
                                        <label>FreshChat Widget Host</label>
                                        <FormInput className="form-control" model="freshChatHost" type="text"/>
                                        <span className={"help-block"}>Optional. Override for the fresh chat host, default is https://wchat.freshchat.com and
                                            is used for the host parameter when initializing the Freshchat script</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="freshChatConfiguration">
                                        <label>FreshChat Configuration</label>
                                        <FormTextArea className="form-control" model="freshChatConfiguration" type="text" required={false} validators={[Validators.json()]} rows={configurationRows} />
                                        <span className={"help-block"}>Optional. Override for the fresh chat widget configuration. See documentation at https://developers.freshchat.com/web-sdk/v1/#customisation-wgt</span>
                                        <span className={"help-block"}>Only enter valid JSON here. This will be used as the configuration parameter when initializing the Freshchat script. i.e. {freshChatConfigurationExample}</span>

                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="custom-control custom-checkbox" model="matiEnabled">
                                        <FormInput className="custom-control-input" model="matiEnabled" id={"matiEnabled"} type="checkbox"/>
                                        <label htmlFor={"matiEnabled"} className={"custom-control-label"}>Enable Mati</label><br/>
                                        <span className={"help-block"}>Enables Mati KYC (https://dashboard.getmati.com)</span>
                                    </FormGroup>
                                    <FormGroup className="form-group mb-3" model="matiClientId">
                                        <label>Mati client id</label>
                                        <FormInput className="form-control" model="matiClientId" type="text"/>
                                        <span className={"help-block"}>Needed for Mati integration</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="custom-control custom-checkbox" model="useAmplitude">
                                        <FormInput className="custom-control-input" model="useAmplitude" id={"useAmplitude"} type="checkbox"/>
                                        <label htmlFor={"useAmplitude"} className={"custom-control-label"}>Enable Amplitude</label><br/>
                                        <span className={"help-block"}></span>
                                    </FormGroup>
                                    <FormGroup className="form-group mb-3" model="amplitudeApiKey">
                                        <label>Amplitude API Key</label>
                                        <FormInput className="form-control" model="amplitudeApiKey" type="text"/>
                                        <span className={"help-block"}>Needed for Amplitude integration</span>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-content">
                                            <div className="ibox-title">
                                                <h5>Actions</h5>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-sm-10 col-sm-offset-2">
                                                    <Submit className="btn btn-primary waves-effect waves-light">Save Settings</Submit>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>


            </Fragment>
        )
    }

}

export default withRouter(SettingsIntegrationsView);